import { _object } from 'utils/interfaces'
import { generateQueryParams } from 'utils'

import CommonService from './common.service'

class TestimonialService extends CommonService {
  async getTestimonials(params: _object) {
    return await this.get(`/testimonials?${generateQueryParams(params)}`)
  }
  async getTestimonialDetails(id: string | undefined) {
    return await this.get(`/testimonials/${id}`)
  }

  async addTestimonial(params: { [key: string]: string }) {
    return await this.post('/testimonials', params)
  }

  async updateTestimonial(id: string | undefined, params: _object) {
    return await this.put(`/testimonials/${id}`, params)
  }

  async deleteTestimonial(id: string) {
    return await this.delete(`/testimonials/${id}`)
  }
}

export const testimonialService = new TestimonialService()
